import styled from 'styled-components'
import { em } from 'polished'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import { Text } from 'shared/Typography'

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  width: 100%;
  overflow: hidden;
  background-color: ${p => p.theme.colors.grayOp06NonTransp};
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  padding-top: ${em(40)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(60)};
    max-width: 50%;
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${em(748)};
    padding-top: ${em(80)};
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${em(20)};
  gap: ${em(20)};
`

export const Prices = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${em(20)};
  gap: ${em(5)};

  ${p => p.theme.mq.upMd} {
    width: 100%;
  }

  ${p => p.theme.mq.upLg} {
  }
`

export const DiscountBadge = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${em(25.5)};
  padding: 0 ${em(5)};
  background-color: var(--color-P50);
  border-radius: ${em(4)};
  color: var(--color-W100);
`

export const Price = styled(Text)`
`

export const OldPrice = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(10)};
  color: var(--color-D30);
`

export const Buttons = styled.div`
  display: flex;
`

